export default __webpack_public_path__ + "static/media/Blacksulphur Wristbands.1c84efe3.jpg";